var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 2.9,
    width: 7.43077,
    height: 7.43077,
    rx: 2.1,
    stroke: "white",
    strokeWidth: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 13.669,
    width: 7.43077,
    height: 7.43077,
    rx: 2.1,
    stroke: "white",
    strokeWidth: 1.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6695,
    y: 2.9,
    width: 7.43077,
    height: 7.43077,
    rx: 2.1,
    stroke: "white",
    strokeWidth: 1.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6695,
    y: 13.669,
    width: 7.43077,
    height: 7.43077,
    rx: 2.1,
    stroke: "white",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSelect);
export default __webpack_public_path__ + "static/media/dashboard-select.0e3f99b75c9b9ba9d2370bcf51690470.svg";
export { ForwardRef as ReactComponent };